<style scoped>
#search_addressbook {
	padding: 0px;
}
</style>

<template>
	<v-container id="search_addressbook" fluid>
		<v-row no-gutters>
			<v-col cols="12" class="toolbar">
				<v-btn small class="d-md-none mr-1 text-capitalize" @click="on_back" v-if="show_result">Show search</v-btn>
				<v-btn small @click="save_worklist()" v-if="show_result" class="mr-1 text-capitalize">Save worklist</v-btn>
				<v-btn small @click="new_search()" class="mr-1 text-capitalize">New search</v-btn>
			</v-col>
			<v-col cols="12" md="4" lg="3" v-if="show_search">
				<v-search-filter
					:meta="meta"
					:search="search" 
					@on_search="do_search()" 
					ref="search" 
				/>
			</v-col>
			<v-col cols="12" md="8" lg="9" v-if="show_result">
				<v-search-results
					ref="results" 
					@stop_recording="$emit('stop_recording')"
					@open_task="task_id => $router.push({ name: 'View Task', params: { 'id': task_id }})"
				/>
			</v-col>
		</v-row>

		<v-new-worklist-dialog
			@saved="worklist => saved_worklist(worklist)"
			ref="new_worklist_dialog"
		/>

		<task_stuck
			ref="stuck"
			@saved="do_search();"
		/>

	</v-container>
</template>

<script>
import search_filter from "@/components/tasks/search_filter";
import search_results from "@/components/tasks/search_results";
import new_worklist_dialog from "@/components/worklist/new_worklist_dialog";
import { searchMixin } from "@/mixins/tasks/searchMixin";
import { metaMixin } from "@/mixins/tasks/metaMixin";

import task_stuck from "@/components/tasks/task_stuck";

export default {
	mixins: [ searchMixin, metaMixin ],
	data() {
		return {
			errormsg: "",
			window_width: 0,
			mode: 0, /* 0 = search, 1 = results */
			show_search: true,
			show_result: true
		}
	},
	components: {
		'v-search-filter': search_filter,
		'v-search-results': search_results,
		'v-new-worklist-dialog': new_worklist_dialog,
		task_stuck
	},
	created() {
		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Search Tasks",
			to: this.$route.path
		});

		this.load_meta_data();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.on_resize);

			// TODO need to check if we've stored search settings and if so re-execute them

			// call resize so we know our window size and apply our mode
			this.on_resize();
		})
	},
	beforeDestroy() { 
		window.removeEventListener('resize', this.on_resize); 
	},
	methods: {
		set_mode(new_mode) {
			this.mode = new_mode;

			this.show_search = (this.mode == 0) || (this.window_width >= 960);
			this.show_result = (this.mode == 1) || (this.window_width >= 960);
		},
		new_search() {
			// go back to our search window
			this.set_mode(0);

			this.$nextTick(() => {
				this.reset_search();
				this.$refs.results.clear_results();
			})
		},
		save_worklist() {
			let wl = {
				id: 0,
				class: "restful.tasks.lists",
				name: "",
				settings: { ...this.search },
				is_dynamic: true,
				details: []
			};

			// open up save dialog
			this.$refs.new_worklist_dialog.open(wl);
		},
		saved_worklist(worklist) {
			this.$router.push({ name: "Tasklist", params: { id: worklist.id }});
		},
		do_search() {
			this.set_mode(1);

			// TODO need to store these search settings somewhere so we return to it

			this.$nextTick(() => {
				this.$refs.results.perform_search(this.search);
			})
		},
		on_back() {
			this.set_mode(0);
		},
		change_status(info) {
			if (this.$store.state.recording.task_id == 0) {
				this.$refs['timesheet'].open(
					info.task_id,
					info.new_status_id,
					0,
					-1
				);				
			}
		},
		set_stuck(info) {
			if (this.$store.state.recording.task_id == 0) {
				this.$refs['stuck'].open(
					info.task_id,
					info.new_status_id,
				);				
			}
		},
		on_resize() {
			this.window_width = window.innerWidth;
			this.set_mode(this.mode)
		}
	}}
</script>
